import { MINUTES } from '@sequencehq/utils/dates'
import { useCubeContext } from 'Cube/communication/internal/cube.domain.context'
import { useOtherQuoteLabel } from 'Cube/view/layouts/quote/hooks/useOtherQuoteLabel'

type UseSupersededQuoteBanner = () => {
  isVisible: boolean
  supersedingQuote: {
    id: string
    label: string
  }
}

/**
 * Names the quote that was accepted for this schedule amendment instead of the one on screen,
 * so the only thing left to do here - archiving - is an obvious choice rather than a guess.
 */
export const useSupersededQuoteBanner: UseSupersededQuoteBanner = () => {
  const ctx = useCubeContext()
  const supersededByQuoteId =
    ctx.queries.rawData.data.quote.amendment?.supersededByQuoteId

  const label = useOtherQuoteLabel({
    quoteId: supersededByQuoteId,
    /**
     * The accepted quote is settled by the time it supersedes this one, so nothing about it can
     * change while the editor is open and the cache is free to answer for it.
     */
    staleTime: 10 * MINUTES
  })

  return {
    isVisible: Boolean(supersededByQuoteId),
    supersedingQuote: {
      id: supersededByQuoteId ?? '',
      label
    }
  }
}
